import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';

import { staticData } from "managers/staticDataManager";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if the cookie consent has already been accepted
    const consent = Cookies.get('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    // Set a cookie to mark consent
    Cookies.set('cookieConsent', 'true', { expires: 15 });
    setShowBanner(false);
  };

  return (
    <div className="cookie-consent-banner" hidden={!showBanner}>
      <div dangerouslySetInnerHTML={{ __html: staticData.loadTerms(useSelector, "ISSUER_COOKIE_CONSENT_MSG") }} />
      <button onClick={handleAcceptCookies}>{staticData.loadTerms(useSelector, "ISSUER_COOKIE_CONSENT_BTN")}</button>
    </div>
  );
};

export default CookieConsent;